export class ModalController {
    constructor($uibModalInstance) {
        this.modalInstance = $uibModalInstance;
        this.dataToSend = {};
        this.dismissData = {};
    }

    close() {
        this.modalInstance.close(this.dataToSend);
    }

    dismiss() {
        this.modalInstance.dismiss(this.dismissData);
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/core/abstracts/controllers/modal-controller.js